import { Action } from "@ngrx/store";
import { ComplexConfig } from "src/app/shared/interfaces/complex-exercise/complex-config";
import { ComplexSubmissionItem } from "src/app/shared/interfaces/complex-exercise/complex-submissions";
import { Guid } from "src/app/shared/types/guid";

export const LOAD_COMPLEX_EXERCISE_CONFIG =
  "[Complex Exercise] Load Complex Exercise Config";
export const LOAD_COMPLEX_EXERCISE_CONFIG_COMPLETED =
  "[Complex Exercise] Load Complex Exercise Config Completed";
export const LOAD_COMPLEX_EXERCISE_CONFIG_FAILED =
  "[Complex Exercise] Load Complex Exercise Config Failed";
export const LOAD_TEACHER_COMPLEX_EXERCISE_DATA =
  "[Complex Exercise] Load Teacher Complex Exercise Data";
export const LOAD_TEACHER_COMPLEX_EXERCISE_DATA_COMPLETED =
  "[Complex Exercise] Load Teacher Complex Exercise Data Completed";
export const LOAD_TEACHER_COMPLEX_EXERCISE_DATA_FAILED =
  "[Complex Exercise] Load Teacher Complex Exercise Data Failed";
export const DOWNLOAD_COMPLEX_SUBMISSIONS_CSV =
  "[Complex Exercise] Download Complex Submissions CSV";
export const DOWNLOAD_COMPLEX_SUBMISSIONS_CSV_COMPLETED =
  "[Complex Exercise] Download Complex Submissions CSV Completed";
export const DOWNLOAD_COMPLEX_SUBMISSIONS_CSV_FAILED =
  "[Complex Exercise] Download Complex Submissions CSV Failed";
export const DOWNLOAD_COMPLEX_BULK_FILES =
  "[Complex Exercise] Download Complex Bulk Files";
export const DOWNLOAD_COMPLEX_BULK_FILES_COMPLETED =
  "[Complex Exercise] Download Complex Bulk Files Completed";
export const DOWNLOAD_COMPLEX_BULK_FILES_FAILED =
  "[Complex Exercise] Download Complex Bulk Files Failed";

export class LoadComplexExerciseConfig implements Action {
  readonly type = LOAD_COMPLEX_EXERCISE_CONFIG;

  constructor(
    public payload: {
      courseId: Guid;
      groupId?: Guid | null;
      exerciseId: Guid;
    },
  ) {}
}

export class LoadComplexExerciseConfigCompleted implements Action {
  readonly type = LOAD_COMPLEX_EXERCISE_CONFIG_COMPLETED;

  constructor(
    public payload: {
      config: ComplexConfig;
    },
  ) {}
}

export class LoadComplexExerciseConfigFailed implements Action {
  readonly type = LOAD_COMPLEX_EXERCISE_CONFIG_FAILED;

  constructor(
    public payload: {
      errorStatus?: number;
    },
  ) {}
}

export class LoadTeacherComplexExerciseData implements Action {
  readonly type = LOAD_TEACHER_COMPLEX_EXERCISE_DATA;

  constructor(
    public payload: {
      courseId: Guid;
      groupId: Guid;
      exerciseId: Guid;
    },
  ) {}
}

export class LoadTeacherComplexExerciseDataCompleted implements Action {
  readonly type = LOAD_TEACHER_COMPLEX_EXERCISE_DATA_COMPLETED;

  constructor(
    public payload: {
      config: ComplexConfig;
      submissions: ComplexSubmissionItem[];
    },
  ) {}
}

export class LoadTeacherComplexExerciseDataFailed implements Action {
  readonly type = LOAD_TEACHER_COMPLEX_EXERCISE_DATA_FAILED;

  constructor(
    public payload: {
      errorStatus?: number;
    },
  ) {}
}

export class DownloadComplexSubmissionsCsv implements Action {
  readonly type = DOWNLOAD_COMPLEX_SUBMISSIONS_CSV;

  constructor(
    public payload: {
      courseId: Guid;
      groupId: Guid;
      exerciseId: Guid;
    },
  ) {}
}

export class DownloadComplexSubmissionsCsvCompleted implements Action {
  readonly type = DOWNLOAD_COMPLEX_SUBMISSIONS_CSV_COMPLETED;
}

export class DownloadComplexSubmissionsCsvFailed implements Action {
  readonly type = DOWNLOAD_COMPLEX_SUBMISSIONS_CSV_FAILED;
}

export class DownloadComplexBulkFiles implements Action {
  readonly type = DOWNLOAD_COMPLEX_BULK_FILES;

  constructor(
    public payload: {
      courseId: Guid;
      groupId: Guid;
      exerciseId: Guid;
    },
  ) {}
}

export class DownloadComplexBulkFilesCompleted implements Action {
  readonly type = DOWNLOAD_COMPLEX_BULK_FILES_COMPLETED;

  constructor(
    public payload: {
      isGenerating: boolean;
      tooltipKey: string;
    },
  ) {}
}

export class DownloadComplexBulkFilesFailed implements Action {
  readonly type = DOWNLOAD_COMPLEX_BULK_FILES_FAILED;

  constructor(
    public payload: {
      tooltipKey: string;
    },
  ) {}
}

export type ComplexExerciseActions =
  | LoadComplexExerciseConfig
  | LoadComplexExerciseConfigCompleted
  | LoadComplexExerciseConfigFailed
  | LoadTeacherComplexExerciseData
  | LoadTeacherComplexExerciseDataCompleted
  | LoadTeacherComplexExerciseDataFailed
  | DownloadComplexSubmissionsCsv
  | DownloadComplexSubmissionsCsvCompleted
  | DownloadComplexSubmissionsCsvFailed
  | DownloadComplexBulkFiles
  | DownloadComplexBulkFilesCompleted
  | DownloadComplexBulkFilesFailed;
